import { locale } from "localization/en";

export const discountReportColumns = [
  { key: "stationCode", text: locale.stationCode, width: "200px" },
  { key: "stationName", text: locale.stationName, width: "200px" },
  { key: "dateAndTime", text: locale.dateAndTime, width: "180px" },
  { key: "salesInvoiceNo", text: locale.salesInvoiceNo, width: "160px" },
  { key: "discount", text: locale.discount, width: "140px" },
  { key: "description", text: locale.description, width: "180px" },
  { key: "sku", text: locale.sku, width: "120px" },
  { key: "qty", text: locale.qty, width: "80px" },
  { key: "unitPrice", text: locale.unitPrice, width: "120px" },
  { key: "discountAmount", text: locale.discountAmount, width: "140px" },
];
